import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { FiEye, FiEyeOff } from "react-icons/fi";
import './SignUp.css';
import API_URL from "./Config";

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [new_password, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [messages, setMessages] = useState([]); // Store all messages
  const [success, setSuccess] = useState(false);
  const [messageTone, setMessageTone] = useState("error");
  const [step, setStep] = useState(1); // Step 1: Enter Email, Step 2: Verify OTP, Step 3: Set New Password
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(180); // 10 minutes in seconds
  const [resendDisabled, setResendDisabled] = useState(false);
  const [emailRegistered, setEmailRegistered] = useState(true);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const latestMessage = messages[messages.length - 1] || "";

  useEffect(() => {
    let interval;

    if (step === 2 && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [step, timer]);

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    switch (field) {
      case "email":
        setEmail(value);
        break;
      case "otp":
        setOtp(value);
        break;
      case "newPassword":
        setNewPassword(value);
        break;
      case "confirmPassword":
        setConfirmPassword(value);
        break;
      default:
        break;
    }
  };

  const handleResendOTP = async () => {
    try {
      // Send a POST request to the /api/resend-otp endpoint to request a new OTP
      const response = await axios.post(
        `${API_URL}/api/resend-otp`,
        { email }
      );

      if (response.data.success) {
        // setTimer(600);
        setTimer(180); // Reset the timer
        setMessageTone("success");
        setMessages([...messages, "OTP sent to your email. Check your inbox."]);
        setResendDisabled(true); // Disable the Resend OTP button temporarily
      } else {
        setMessageTone("error");
        setMessages([...messages, response.data.message]);
      }
    } catch (error) {
      console.error("Error:", error);
      setMessageTone("error");
      setMessages([...messages, "An error occurred while resending OTP."]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      if (step === 1) {
        if (!/^\S+@\S+\.\S+$/.test(email)) {
          setIsLoading(false);
          setMessageTone("error");
          setMessages([...messages, "Please enter a valid email address."]);
          return;
        }

        const response = await axios.post(
          `${API_URL}/api/check-email-exists`,
          { email }
        );

        if (response.data.success) {
          setEmailRegistered(true);
          const response2 = await axios.post(
            `${API_URL}/api/forgot-password`,
            { email }
          );

          if (response2.data.success) {
            setStep(2);
            setSuccess(true);
            setMessageTone("success");
            const successMessage = `To continue, complete this verification step. We've sent an OTP to the email ${email}. Please enter it below to complete verification.`;
            setMessages([...messages, successMessage]);
          } else {
            setMessageTone("error");
            setMessages([...messages, response2.data.message]);
            setSuccess(false);
          }
        } else {
          setEmailRegistered(false);
          setMessageTone("error");
          setMessages([...messages, "Email is not registered"]);
          setIsLoading(false);
        }
      }

       else if (step === 2) {
        // Send a POST request to the /api/verify-otp endpoint to verify OTP
        const response = await axios.post(
          `${API_URL}/api/verify-otp`,
          { email, otp }
        );
        if (response.data.success) {
          setStep(3);
          setSuccess(true);
          setMessageTone("success");
          setMessages([...messages, "OTP verified successfully. Set your new password."]);
        } else {
          setSuccess(false);
          setMessageTone("error");
          setMessages([...messages, response.data.message]);
        }
      } else if (step === 3) {
        if (new_password !== confirmPassword) {
          setIsLoading(false);
          setMessageTone("error");
          setMessages([...messages, "Passwords do not match."]);
          return;
        }
        // Send a POST request to update the password
        const response = await axios.post(
          `${API_URL}/api/reset-password`,
          { email, otp, new_password }
        );

        if (response.data.success) {
          setSuccess(true);
          setMessageTone("success");
          setMessages([...messages, "Password reset successful. You can now log in with your new password."]);
          window.setTimeout(() => {
            navigate('/login');
          }, 2000);
        } else {
          setSuccess(false);
          setMessageTone("error");
          setMessages([...messages, response.data.message]);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      setMessageTone("error");
      setMessages([...messages, "An error occurred while processing your request."]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      <div className="row justify-content-center forgot-contant">
        {/* <div className="col-md-6"> */}
        {/* <div className="forgot-image">
            <img src="/logo100.png" alt="Logo" className="forgot-logo" />
        </div> */}
        
          <div className="card forgot">
            <div className="card-body">
              <h3 className="card-title forgot-card" >
                {step === 1 && (
                  <div>
                    <div className="password">Password assistance</div>
                    <p className="small-font">
                      <span style={{ fontSize: '14px' }}>
                        Enter the email address associated with your account.
                      </span>
                    </p>
                  </div>
                )}
                {step === 2 && "Verification required"}
                {step === 3 && "Set New Password"}
              </h3>
              <form onSubmit={handleSubmit}>
                {step === 1 && (
                  <div className="form-groups">
                    {latestMessage ? (
                      <p className="small-font">
                        <span
                          className={`forgot-message forgot-message--${messageTone}`}
                        >
                          {latestMessage}
                        </span>
                      </p>
                    ) : null}
                    <label className="forgot-lable">Email address</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => handleInputChange(e, "email")}
                      required
                    />
                  </div>
                )}
                {step === 2 && (
                  <div className="form-groups">
                    {latestMessage ? (
                      <p className="small-font">
                        <span
                          className={`forgot-message forgot-message--${messageTone}`}
                        >
                          {latestMessage}
                        </span>
                      </p>
                    ) : null}
                    <label  className="forgot-lable">Enter OTP</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter the OTP sent to your email"
                      value={otp}
                      onChange={(e) => handleInputChange(e, "otp")}
                      required
                    />
                    {/* Display all messages */}
                    {/* {messages.map((message, index) => (
                      <div key={index} className={`mt-3 alert ${success ? "alert-success" : "alert-danger"}`} role="alert">
                        {message}
                      </div>
                    ))} */}
                  </div>
                )}
                {step === 3 && (
                  <>
                    {latestMessage ? (
                      <div className="form-groups">
                        <p className="small-font">
                          <span
                            className={`forgot-message forgot-message--${messageTone}`}
                          >
                            {latestMessage}
                          </span>
                        </p>
                      </div>
                    ) : null}
                    <div className="form-groups">
                      <label className="forgot-lable">New Password</label>
                      <div className="forgot-password-input-wrap">
                        <input
                          type={showNewPassword ? "text" : "password"}
                          className="form-control forgot-password-input"
                          placeholder="Enter your new password"
                          value={new_password}
                          onChange={(e) => handleInputChange(e, "newPassword")}
                          required
                        />
                        <button
                          aria-label={showNewPassword ? "Hide password" : "Show password"}
                          className="forgot-password-toggle"
                          onClick={() =>
                            setShowNewPassword((currentValue) => !currentValue)
                          }
                          type="button"
                        >
                          {showNewPassword ? <FiEyeOff /> : <FiEye />}
                        </button>
                      </div>
                    </div>
                    <div className="form-groups">
                      <label className="forgot-lable">Password again</label>
                      <div className="forgot-password-input-wrap">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          className="form-control forgot-password-input"
                          placeholder="Confirm your new password"
                          value={confirmPassword}
                          onChange={(e) => handleInputChange(e, "confirmPassword")}
                          required
                        />
                        <button
                          aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                          className="forgot-password-toggle"
                          onClick={() =>
                            setShowConfirmPassword((currentValue) => !currentValue)
                          }
                          type="button"
                        >
                          {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                        </button>
                      </div>
                    </div>
                  </>
                )}
                <button
                  type="submit"
                  className="continue1"
                  disabled={isLoading}
                >
                  {isLoading
                    ? "Loading..."
                    : step === 1
                    ? "Continue"
                    : step === 2
                    ? "Verify OTP"
                    : "Reset Password"}
                </button>
              </form>
              {step === 2 && (
                <div className="text-center">
                  {timer > 0 ? (
                    <p>Resend OTP in {Math.floor(timer / 60)}:{timer % 60} seconds</p>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-link-otp"
                      onClick={handleResendOTP}
                      disabled={resendDisabled}
                    >
                      Resend code
                    </button>
                  )}
                   <p className="small-font">
                      <span style={{ fontSize: '15px', color: 'rgb(219, 38, 38)', marginLeft: '7px'}}>
                      OTP is valid for 10 minutes.</span> </p>
                </div>
              )}
            </div>
          </div>
      
      </div>
    </div>
  );
}

export default ForgotPassword;
